import Page from '../../classes/Page'
import Hero from '../../modules/Hero'
import { app } from '../../utils/store'

export default class Easy10 extends Page {
    constructor() {
        super({
            id: 'easy10',
            element: '[data-app-page]',
            elements: {
                hero: '[data-carousel="hero"]',
            },
        })
    }

    create() {
        super.create()
        if (this.elements.hero) { this.createHero() }
    }

    createHero() {
        this.hero = new Hero({ element: this.elements.hero })
    }

    addEventListeners() {

    }

    destroy() {
        super.destroy()
    }
}